export const IconArrow = (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
        <g clipPath="url(#clip0_3190_118456)">
            <path
                d="M14.5 26C21.1274 26 26.5 20.6274 26.5 14C26.5 7.37258 21.1274 2 14.5 2C7.87258 2 2.5 7.37258 2.5 14C2.5 20.6274 7.87258 26 14.5 26Z"
                fill="currentColor"
            />
            <path
                d="M12.7178 19.2832L17.5004 14.5006L17.588 14.4132L12.6963 9.52148"
                stroke="white"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3190_118456">
                <rect width="28" height="28" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);
